module.exports = __webpack_public_path__ + "static/media/img_2_2.3189037a.png";